import { Observable, firstValueFrom, from } from 'rxjs';

import { AccessoryEquipmentType } from '../model/accessoryEquipmenType';
import { DexieService } from './dexieService';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { OnlineService } from './online.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class AccessoryEquipmentTypeService {

    constructor(private http: HttpClient,
        private dexieService: DexieService,
        private onlineService: OnlineService) {    }

    findAll(): Observable<any> {
        if (this.onlineService.latestOnline) {
            const url = environment.coreUrl + '/accessoryEquipmentType/';

            return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
        } else {
            return from(this.dexieService.accessoryType.toArray().timeout(30000));
        }
    }

    async saveAccessoryTypesToDexie(): Promise<void> {
        const res = await firstValueFrom(this.findAll());
        if (!res) return;

        await this.dexieService.accessoryType.clear();

        await Promise.all(res.map(data => this.dexieService.accessoryType.put(data, data.id)));
    }

}
